__turbopack_context__.v({
  "border": "navigation-module__mix1Pa__border",
  "bottom": "navigation-module__mix1Pa__bottom",
  "content": "navigation-module__mix1Pa__content",
  "hamburger": "navigation-module__mix1Pa__hamburger",
  "header": "navigation-module__mix1Pa__header",
  "hide": "navigation-module__mix1Pa__hide",
  "horizontal": "navigation-module__mix1Pa__horizontal",
  "inner": "navigation-module__mix1Pa__inner",
  "input": "navigation-module__mix1Pa__input",
  "line": "navigation-module__mix1Pa__line",
  "loaded": "navigation-module__mix1Pa__loaded",
  "nav": "navigation-module__mix1Pa__nav",
  "open": "navigation-module__mix1Pa__open",
  "socialLinks": "navigation-module__mix1Pa__socialLinks",
  "text-blocks": "navigation-module__mix1Pa__text-blocks",
  "top": "navigation-module__mix1Pa__top",
  "vertical": "navigation-module__mix1Pa__vertical",
});
